import { render, staticRenderFns } from "./ReligionInfo.vue?vue&type=template&id=00bd5763&"
import script from "./ReligionInfo.vue?vue&type=script&lang=js&"
export * from "./ReligionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports